webpackJsonp([123985599566322],{

/***/ 1338:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"The future of WordPress","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/the-future-of-wordpress","createdAt":"2014-10-14T06:35:09.097Z","blogAuthor":{"fields":{"name":"Dean Wenick","slug":"blog/author/dean-wenick"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/2iCAV4PTTe48S66a8YcCa4/e05943dddfc179e5dd419902dd3da4f5/blog-post-blog-the-future-of-wordpress.jpg"}}}}}]},"authorJson":{"name":"Dean Wenick","slug":"blog/author/dean-wenick","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/dean-wenick"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-dean-wenick-193de3d062a3e80e5e6a.js